import React from 'react'
import { propType } from 'graphql-anywhere'
import AccordionItem from './accordion-item'
import AccordionComponentFields from '../../../graphql/fragments/accordion-component.gql'
import styles from './accordion-component.css'

const AccordionComponent = ({ accordionComponent }) => {
  return (
    <div className={styles.accordionComponentWrapper}>
      <div className={styles.header}>{accordionComponent.header}</div>
      {
        accordionComponent.accordions.map(accordion => <AccordionItem accordion={accordion} />)
      }
    </div>
  )
}

AccordionComponent.propTypes = {
  accordionComponent: propType(AccordionComponentFields).isRequired
}

export default AccordionComponent
